import React from 'react';
import { translate } from 'react-i18next';
import { StyleSheet, ScrollView } from 'react-native';

import DayHeader from './DayHeader';
import DayFooter from './DayFooter';
import MealRows from './MealRows';

const MealsForDay = ({
    t,
    day,
    days,
    mealPlans,
    mealPreferences,
    openMealModal,
    toggleFoodPreferencesModal,
    changeDay,
    getDays,
    closeMealModal,
}) => {
    const dayOfWeek = day.format('dddd');
    const selectedDay = days.find((d) => {
        return d.dayOfWeek === dayOfWeek
    });
    const dayCals = mealPlans.caloriesForDayNewIngredientsModel[selectedDay.dayOfWeek];
    const dayCarbs = mealPlans.carbsForDay.get(selectedDay.dayOfWeek);
    const dayFat = mealPlans.fatForDay.get(selectedDay.dayOfWeek);
    const dayProtein = mealPlans.proteinForDay.get(selectedDay.dayOfWeek);
    const mealPlan = mealPlans.mealSchedule.get(selectedDay.dayOfWeek);

    return (
        <ScrollView style={styles.container}>
            <DayHeader
                t={t}
                day={selectedDay}
                changeDay={changeDay}
                getDays={getDays}
                mealPreferences={mealPreferences}
                toggleFoodPreferencesModal={toggleFoodPreferencesModal}
            />
            <DayFooter
                t={t}
                day={selectedDay}
                mealsForDay={mealPlan}
                dayCals={dayCals}
                dayCarbs={dayCarbs}
                dayFat={dayFat}
                dayProtein={dayProtein}
                toggleFoodPreferencesModal={toggleFoodPreferencesModal}
            />
            <MealRows
                t={t}
                mealsForDay={mealPlan}
                openMealModal={openMealModal}
                closeMealModal={closeMealModal}
            />
        </ScrollView>
    );
}

MealsForDay.propTypes = {
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
    }
});

export default translate(['nutrition'], { wait: true })(MealsForDay);
